import { set } from 'lodash/fp';
import { Storage } from './../../service';

import { createReducer } from './../../service/Utils';

const initialState = {
  loading: false,
  error: false,
  errorData: {},
  data: Storage.loadStateData() || {},
  test: {},
  request: {
    name: '',
    query: '',
    data: null
  }
};

export default createReducer(initialState, {
  SET_DATA: (state, payload) => {
    if (payload[0].includes('filter')) {
      const oldFilterData = Storage.getDataByKey('filter');
      Storage.saveStateData({
        filter: { ...oldFilterData, [payload[0].split('.').pop()]: payload[1] }
      });
    }
    return set(payload[0], payload[1], state);
  },
  LOAD_DATA: (state) => {
    return { ...state, error: false };
  },
  LOAD_DATA_SUCCESS: (state, payload) => {
    return set(payload[0], payload[1], state);
  },
  CHANGE_LOADING_STATE: (state, payload = false) => {
    return { ...state, loading: payload };
  },
  CLEAR_DATA_SUCCESS: (state, payload) => {
    return set(payload[0], undefined, state);
  },
  LOAD_DATA_ERROR: (state, payload) => {
    return set(payload[0], payload[1], state);
  },
  CLEAR_DATA_ERROR: (state, payload) => {
    return set(payload[0], undefined, state);
  },
  FETCH_REQUEST: (state, { query = {}, name, options = {}, ...params }) => {
    const { notSaveQuery = false } = options;
    const { dateFrom, dateTo } = query;
    if (dateFrom && dateTo && !notSaveQuery) {
      const currentFilterData = Storage.getDataByKey('filter');
      Storage.saveStateData({
        filter: {
          ...currentFilterData,
          [name]: { ...query }
        }
      });
    }
    return { ...state, request: { query, name, params } };
  },
  SET_REQUEST: (state, payload) => {
    return { ...state, request: payload };
  },
  SEND_DATA: (state, payload) => {
    return { ...state, request: payload };
  },
  RESET: () => {
    return { ...initialState, data: {} };
  }
});
